import { OtoIndividualTransferPersonActions } from '../../lib/types/models/enrollment/oto-individual-enrollments'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// What the caller may do with the accueil-transfert person: the backend decides when a parent may
// see it (a window before the departure) and when the provider may still record it.
export function getOtoIndividualTransferPersonActions(enrollmentId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getOtoIndividualTransferPersonActions.url, {
        id: enrollmentId
      })
    )
    .get<OtoIndividualTransferPersonActions>()
}
